{
  "nl": {
    "chart": {
      "type": {
        "bar": "Staafdiagram",
        "bubble": "Bubble chart",
        "doughnut": "Donut chart",
        "horizontalBar": "Horizontaal staafdiagram",
        "line": "Lijndiagram",
        "multiAxis": "Multi-as diagram",
        "pie": "Taartdiagram",
        "polarArea": "Polar area chart",
        "radar": "Radardiagram",
        "stackedBar": "Gestapeld staafdiagram"
      }
    }
  }
}